import { __assign, __awaiter, __generator } from "tslib";
import { resolveConfig, } from '@office-start/config-resolver-service';
import { isCommercialUser, isConsumerUser, isEmbed, isHwa as isPwa, } from '@office-start/config-resolver-utility';
import { isUwp, isWebView2 } from '@office-start/device-detection-utility';
import { createCacheNetworkRaceOperation, } from '@office-start/persistence-strategies';
import { readFromSimplePersistence, writeToSimplePersistence, } from '@office-start/simple-persistence';
import { getUserEntitlementsFromNetwork } from './getUserEntitlementsFromNetwork';
import { parseConfigKey, userEntitlementsPersistenceKey, userEntitlementsPersistenceVersion, } from './models/Constants';
function getUserEntitlementsFromClient(options) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, resolveConfig(parseConfigKey, options)];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data];
            }
        });
    });
}
function handleExecuteUserEntitlementsDataFlow(identity, officeComponentContext) {
    return __awaiter(this, void 0, void 0, function () {
        var data, promiseObject, isCommercialUser_1, isConsumerUser_1, isPwa_1, isEmbed_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    promiseObject = {
                        isCommercialUserPromise: isCommercialUser(),
                        isConsumerUserPromise: isConsumerUser(),
                        isPwaPromise: isPwa(),
                        isEmbedPromise: isEmbed(),
                    };
                    return [4 /*yield*/, getUserEntitlementsFromClient(officeComponentContext)];
                case 1:
                    data = _a.sent();
                    if (!(data === undefined)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getUserEntitlementsFromNetwork(officeComponentContext.correlationId, function () { return Promise.resolve(identity); }, officeComponentContext.inMockMode, officeComponentContext.officeHomeApiRoot, officeComponentContext.workload, officeComponentContext.getAccessToken, officeComponentContext.jwtAuthEnabled)];
                case 2:
                    data = _a.sent();
                    _a.label = 3;
                case 3:
                    if (!(data !== null)) return [3 /*break*/, 8];
                    return [4 /*yield*/, promiseObject.isCommercialUserPromise];
                case 4:
                    isCommercialUser_1 = _a.sent();
                    return [4 /*yield*/, promiseObject.isConsumerUserPromise];
                case 5:
                    isConsumerUser_1 = _a.sent();
                    return [4 /*yield*/, promiseObject.isPwaPromise];
                case 6:
                    isPwa_1 = _a.sent();
                    return [4 /*yield*/, promiseObject.isEmbedPromise];
                case 7:
                    isEmbed_1 = _a.sent();
                    return [2 /*return*/, __assign(__assign({}, data), { isCommercialUser: isCommercialUser_1, isConsumerUser: isConsumerUser_1, isEmbed: isEmbed_1, isPwa: isPwa_1, isPwaInUwp: isPwa_1 && isUwp(), isPwaInWebView2: isPwa_1 && isWebView2() })];
                case 8: return [2 /*return*/, null];
            }
        });
    });
}
export function executeUserEntitlementsDataFlow(identity, officeComponentContext) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, createCacheNetworkRaceOperation(function () {
                    return handleExecuteUserEntitlementsDataFlow(identity, officeComponentContext);
                }, function () {
                    return readFromSimplePersistence({
                        userId: identity.puid,
                        collectionName: userEntitlementsPersistenceKey,
                        collectionVersion: userEntitlementsPersistenceVersion,
                        key: userEntitlementsPersistenceKey,
                    });
                }, function (networkResult) {
                    return writeToSimplePersistence({
                        userId: identity.puid,
                        collectionName: userEntitlementsPersistenceKey,
                        collectionVersion: userEntitlementsPersistenceVersion,
                        key: userEntitlementsPersistenceKey,
                        data: networkResult,
                    });
                })];
        });
    });
}
//# sourceMappingURL=executeUserEntitlementsDataFlow.js.map